/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {
	var $win = jQuery(window),
		$body = jQuery('body');

		var outerLocationDiv = '<div class="live-ticket-container"></div>';
		jQuery('.umg_live_table tr').each(function() {
			jQuery(this).last().append(outerLocationDiv);
		});

		jQuery('.live-ticket-container').each(function() {
			var nearestVenue = jQuery(this).siblings(".umg_live_tickets");
			jQuery(this).append(nearestVenue);
			var nearestLocation = jQuery(this).siblings(".umg_live_rsvp");
			jQuery(this).append(nearestLocation);
	
		  });

		var slickOpts = {
			slidesToShow: 1,
			slidesToScroll: 1,
			//centerMode: true,
			easing: 'swing', // see http://api.jquery.com/animate/
			// speed: 700,
			dots: true,
			arrows: false,
			customPaging: function(slick,index) {
				return '<a>' + (index + 1) + '</a>';
			}
		  };
		  // Init slick carousel
		  jQuery('.album-container').slick(slickOpts);

	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	jQuery("#terms").css('font-size', '14px');

	if( !$body.hasClass('home') ) {

	jQuery(".nav-subscribe a").on("click", function(){
		jQuery(".mask").addClass("active");

		jQuery(".open").removeClass('opened');
		if ( jQuery(this).parents('.off-canvas') ) {
			jQuery('.js-off-canvas-overlay').trigger('click');
		}
	});
}

setTimeout(function(){
	jQuery(".mask-2").addClass("active");
}, 15000);
	
	// Function for close the Modal
	
	function closeModal(){
		jQuery(".mask").removeClass("active");
	}
	
	// Call the closeModal function on the clicks/keyboard
	
	jQuery(".close, .mask").on("click", function(){
		closeModal();
	});
	
	jQuery(document).keyup(function(e) {
		if (e.keyCode == 27) {
		closeModal();
		}
	});

	function closeModal2(){
		jQuery(".mask-2").removeClass("active");
	}
	
	// Call the closeModal function on the clicks/keyboard
	
	jQuery(".close, .mask-2").on("click", function(){
		closeModal2();
	});
	
	jQuery(document).keyup(function(e) {
		if (e.keyCode == 27) {
		closeModal2();
		}
	});


	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});
	jQuery(window).on('load', function() {
		jQuery('#ae-cform-input-reg-email-1').attr('placeholder', 'Email');

		jQuery('.top-bar .menu-bars').on('click', function() {
			jQuery(this).find('.fas').toggleClass('fa-times');
		});
		jQuery('.js-off-canvas-overlay').on('click', function() {
			jQuery('.top-bar .menu-bars .fas').removeClass('fa-times');
		});

		jQuery('.js-subscribe a').on('click', function(e) {
			e.preventDefault();

			var $target = jQuery(this).attr('href');

			jQuery('html, body').animate({
				scrollTop: jQuery($target).offset().top
			}, 800);

			if ( jQuery(this).parents('.off-canvas') ) {
				jQuery('.js-off-canvas-overlay').trigger('click');
			}
		});
		

		if( $body.hasClass('home') ) {
			var $banner = jQuery('.js-banner'),
				$videos = jQuery('.js-video-list'),
				$releases = jQuery('.js-release-list'),
				$menu = jQuery('#main-nav li a');

			// $menu.on('click', function(e) {
			// 	var $title = jQuery(this).attr('title').toLowerCase();

			// 	if($title) {
			// 		e.preventDefault();

			// 		jQuery('.menu-primary li').removeClass('active');
			// 		jQuery(this).parent().addClass('active');

			// 		jQuery('html, body').animate({
			// 			scrollTop: jQuery('.section-'+$title).offset().top - 64
			// 		}, 800);
			// 	}
			// });
			
			$banner.slick({
				dots: false,
				fade: true,
				cssEase: 'linear',
				responsive: [
				  {
					breakpoint: 815,
					settings: {
						arrows: false
					}
				  }
				]
			});

			jQuery('.section-banner').addClass('init');

            $banner.on('beforeChange', function(event, slick, currentSlide, nextSlide){
              $banner.addClass('is-sliding');
            });
      
            $banner.on('afterChange', function(event, slick, currentSlide){
              $banner.removeClass('is-sliding');
            });

			// $releases.slick({
			// 	asNavFor: '.album-cover-list'
			// });

			// jQuery('.album-cover-list').slick({
			// 	arrows: false,
			// 	dots: false,
			// 	fade: true,
			// 	cssEase: 'linear',
			// 	asNavFor: '.js-release-list',
			// 	focusOnSelect: true
			// });

			jQuery('.js-news-list').slick({
				dots: false,
				centerPadding: '15%',
				slidesToShow: 1,
				slidesToScroll: 1,
				centerMode: true,
				arrows: true,
				responsive: [
					{
					  breakpoint: 815,
					  settings: {
						centerMode: false,
						centerPadding: '0',
						arrows: false,
						dots: true,
					  }
					}
				  ]
			});

			$releases.slick({
				dots: false,
				slidesToShow: 4,
				slidesToScroll: 4,
				arrows: true,
				responsive: [
					{
					  breakpoint: 815,
					  settings: {
						  slidesToShow: 1,
						  slidesToScroll: 1,
					  }
					}
				  ]
			});

            // $releases.on('afterChange', function(event, slick, currentSlide){
            //   $releases.addClass('slided');
            // });

			$videos.slick({
				dots: false,
				// fade: true,
				// cssEase: 'linear',
				slidesToShow: 2,
				slidesToScroll: 1,
				arrows: true,
				responsive: [
					{
					  breakpoint: 815,
					  settings: {
						  slidesToShow: 1,
					  }
					}
				  ]
			});
      
            $videos.on('afterChange', function(event, slick, currentSlide){
              $videos.addClass('slided');
            });

			jQuery('.article-video .button').on('click', function(e) {
				e.preventDefault();
		
				var youtubeID = jQuery(this).data('id'),
					embedCode = "<div class='media-youtube-video'><iframe src='https://www.youtube.com/embed/" + youtubeID + "?showinfo=0&autohide=1&rel=0&autoplay=1&wmode=transparent' frameborder='0' allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture' allowfullscreen></iframe></div>",
					$parent = jQuery(this).parents('.type-video');
					
				if (!document.querySelector('.media-youtube-video')) {
					$parent.addClass('playing');
					$parent.append(embedCode);
					jQuery('.js-video-list').addClass('has-embed');
				} else {
					$parent.removeClass('playing');
					jQuery('.media-youtube-video').remove();
					jQuery('.js-video-list').removeClass('has-embed');
				}
			});
			jQuery('.js-video-list > button').on('click', function(){
				if (jQuery('.article-video').hasClass('playing')) {
					jQuery('.media-youtube-video').remove();
					jQuery('.article-video').removeClass('playing');
					jQuery('.js-video-list').removeClass('has-embed');
				}
			});

			jQuery('.js-intro-arrow').on('click', function(e){
				e.preventDefault();

				jQuery('html, body').animate({
					scrollTop: jQuery('.section-about').offset().top - 64
				}, 500);
			});

			jQuery('.main-home .section').each(function(){
				var self = jQuery(this);
			
				jQuery(this).waypoint({
					handler: function(direction) {
						// if(direction == 'down') {
						// }

						// jQuery('.main-home .section').removeClass('show');
						self.addClass('show');
					}, offset: '50%'
				});
			});

			if( $win.width() < 480) {

				var waypoints = jQuery('.section-about').waypoint({
					handler: function(direction) {
					  if(direction == 'up') {
						jQuery('#top-bar-menu .logo').removeClass('show');
					  } else {
						jQuery('#top-bar-menu .logo').addClass('show');
					  }
					}, offset: '0'
				  });
			}
		}
	});

	// var prevScrollpos = window.pageYOffset;
	// window.onscroll = function() {
	// var currentScrollPos = window.pageYOffset;

	jQuery(window).scroll(function() {
	    var scroll = jQuery(window).scrollTop();
      
	    if (scroll >= 970) {
			jQuery('.top-bar').addClass('show');
	    } else {
			jQuery('.top-bar').removeClass('show');
	    }
	});

	// console.log(currentScrollPos, 'current');
	// if (prevScrollpos > currentScrollPos + 1000 ) {
	// 	jQuery('.top-bar').removeClass('show');
	// } else {
	// 	jQuery('.top-bar').addClass('show');
	// }
	// prevScrollpos = currentScrollPos;
	// }

	var page_releases = 2;
			
			jQuery( function($) {
			  jQuery( 'body' ).on( 'click', '.loadmore-releases', function() {
				var data = {
				  'action': 'load_posts_by_ajax_releases',
				  'page': page_releases,
				  'security': release.security
				};

				jQuery.post( release.ajaxurl, data, function( response ) {			
					
				  if( $.trim(response) != '') {
					jQuery( '.music-list' ).append( response );
					page_releases++;
				  } else {
					jQuery( '.loadmore-releases' ).hide();
					jQuery( ".no-more-post" ).html( "No More Post Available" );
				  }
				});
			  });
			});

}); 